import React from 'react'
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/about-background-image.png";
import { BsFillPlayCircleFill } from 'react-icons/bs';

const About = () => {
  return (<div className="about-section-container">
    <div className="about-background-image-container">
        <img src={AboutBackground} alt=""/>
    </div>
    <div className="about-section-image-container">
        <img src={AboutBackgroundImage} alt=""/>
    </div>
    <div className='about-section-text-container'>
    <p className='primary-subheading'>About</p>
    <h1 className='primary-heading'>
        Food is important
        </h1>
    <p className='primary-text'>
    At Retro Foodie, we take you back to the golden days of food, serving up the best-loved classics with a twist. From hearty diner-style burgers to creamy milkshakes and crispy fries, our menu is packed with comfort food that transports you to a simpler time.
    </p>
    <p className='primary-text'>
    Our retro-inspired décor brings back the charm of the '50s and '60s, featuring neon lights, checkerboard floors, and vintage posters that set the scene for an unforgettable dining experience. Whether you're indulging in a classic grilled cheese sandwich with tomato soup or sharing a decadent banana split, Retro Bites is where old-school favorites meet modern flavors.
    </p>
        <div className='about-buttons-container'>
            <button className='secondary-button' >Learn More</button>
            <button className='watch-video-button'><BsFillPlayCircleFill/>Watch Video</button>
        </div>
    </div>
      
    </div>
  )
}

export default About
